import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Container,
  TextField,
} from "@material-ui/core";
// import TextEditorComponent from "../textEditor/TextEditor";
import ImageUpload from "../../containers/upload/imageUpload";
import { Typography } from "@mui/material";
import Switch from '@mui/material/Switch';
import FormControl from '@mui/material/FormControl';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import { alpha, styled } from '@mui/material/styles';
import { pink } from '@mui/material/colors';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';

const useStyles = makeStyles((theme) => ({
  cardRoot: {
    padding: "3vh 3%",
    "@media (max-width: 600px)": {
      padding: "3vh 0%",
      marginLeft: "-15px",
      width: "109%",
    },
  },
  cardContent: {
    display: "flex",
    flexDirection: "column",
  },
  cardActions: {
    display: "flex",
    justifyContent: "flex-end",
    paddingRight: "15px",
  },
  title: {
    margin: "10px 0",
  },
  input: {
    margin: "10px 0",
  },
}));

const PinkSwitch = styled(Switch)(({ theme }) => ({
  '& .MuiSwitch-switchBase.Mui-checked': {
    color: pink[600],
    '&:hover': {
      backgroundColor: alpha(pink[600], theme.palette.action.hoverOpacity),
    },
  },
  '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
    backgroundColor: pink[600],
  },
}));


export default ({ onSubmit, openToast, isLoading, baseGalleryData }) => {
  const classes = useStyles();
  const [type, setType] = React.useState(baseGalleryData._id ? baseGalleryData.category : 'photo');

  const handleType = (event) => {
    setType(event.target.value);
  };
  const [external, setExternal] = React.useState({extenalLink:false});
  const [state, setState] = useState(
    baseGalleryData.id
      ? {
          title: baseGalleryData.title,
          category: baseGalleryData.category,
          imageUrl: baseGalleryData.imageUrl,
          thumbnail: baseGalleryData.thumbnail
        }
        : {
          title: "",
          category: "",
          imageUrl: null,
          thumbnail:""
        }
  );
  const handleChange = (event) => {
    const { id, value } = event.target;
    
    setState({ ...state, [id]: value });
  };
  const handleChangeText = (value) => {
    setState((prevState) => ({ ...prevState, textContent: value }));
  };
  const handleFileUploaded = (imageUrl) =>
    setState((prevState) => ({ ...prevState, imageUrl }));

  const handleSubmit = () => {
    if(external.extenalLink){
      state.category = type;
      state.thumbnail = state.imageUrl
    }
    state.category = type;
    if ((!state.title, !state.category, !state.imageUrl) && !external.extenalLink) {
      return openToast({
        message: "An image field can not be Empty",
        type: "warning",
      });
    }
    console.log(state, "=== these are the data");
    onSubmit(state);
    // setState({
    //   imageUrl:"",
    //   title:""
    // })
  };

  const handleExternalLink = (event) => {
    setExternal({
      ...external,
      [event.target.name]: event.target.checked,
    });
  };

  return (
    <Container justify="center" maxWidth="md">
      <Card className={classes.cardRoot}>
        <CardHeader title={baseGalleryData._id ? `Update Image` :  `Upload a new Image`} />
        <CardContent className={classes.cardContent}>
          <TextField
            id="title"
            label="caption"
            variant="outlined"
            className={classes.title}
            value={state.title}
            onChange={handleChange}
          />
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">Category</InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={type}
              label="Category"
              disabled
              onChange={handleType}
            >
              <MenuItem value="photo">Photos</MenuItem>
            </Select>
          </FormControl>
          {type === 'photo' && <FormControl component="fieldset" variant="standard">
            <FormGroup>
              <FormControlLabel
                control={
                  <PinkSwitch checked={external.extenalLink} onChange={handleExternalLink} name="extenalLink" />
                }
                label="use external link"
              />
            </FormGroup>
            
          </FormControl>}

          {!external.extenalLink && type === 'photo' && <div>
            <Typography>Image</Typography>
          <ImageUpload
            isSmall
            onFileUploaded={handleFileUploaded}
            defaultImg={state.imageUrl}
          />
          </div>}
          {(external.extenalLink || type === 'video') && <TextField
            id="imageUrl"
            label="external link"
            variant="outlined"
            className={classes.title}
            value={state.imageUrl}
            onChange={handleChange}
          />}
          
          {/* <TextField
            id="external Url"
            label="external Url"
            multiline
            rows={4}
            value={state.summary}
            onChange={handleChange}
            variant="outlined"
            className={classes.input}
          /> */}
        </CardContent>
        <CardActions className={classes.cardActions}>
          <Button
            variant="outlined"
            onClick={handleSubmit}
            sx={{
              color: "#E00186",
              border: "1px solid #E00186",
              "&:hover": {
                color: "#fff",
                backgroundColor: "#E00186",
                border: "1px solid #E00186",
              },
            }}
          >
            Upload Image
          </Button>
        </CardActions>
      </Card>
    </Container>
  );
};
